export const SET_RECORDS = 'SET_RECORDS'
export const SET_RECORD_TYPES = 'SET_RECORD_TYPES'
export const SET_RESPONSIBLE_TYPES = 'SET_RESPONSIBLE_TYPES'
export const SET_ESTABLISHMENTS = 'SET_ESTABLISHMENTS'
export const SET_STATS = 'SET_STATS'
export const SET_SELECTED_RECORD = 'SET_SELECTED_RECORD'
export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'
